import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getBranchList } from "../redux/actions/branchAction";
import SideNav from "./sidenav";
import Header from "./header";
import { FadeLoader } from "react-spinners";
import AddBranchItemModal from "./AddBranchItemModal";

const BranchManagement = () => {
  const dispatch = useDispatch();
  const { branchList, loader } = useSelector((store) => store.branchReducer);
  const { storeData } = useSelector((store) => store.store);
  console.log("storeData", storeData);

  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedBranchForAdd, setSelectedBranchForAdd] = useState(null);

  const handleOpenAddModal = (branch) => {
    setSelectedBranchForAdd(branch);
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setSelectedBranchForAdd(null);
  };

  useEffect(() => {
    dispatch(getBranchList());
  }, []);

  const branches = branchList?.data?.result || [];
  console.log("selectedBranchForAdd", selectedBranchForAdd);

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FadeLoader color="#003a6b" />
        </div>
      )}
      <Header />
      <SideNav />
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="MainBox">
              <div className="Container">
                {/* Header Section */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      color: "#333",
                      margin: "0",
                    }}
                  >
                    My Branches
                  </h2>
                  <Link
                    to="/branch-add"
                    className="btn"
                    style={{
                      backgroundColor: "#003a6b",
                      color: "#fff",
                      fontWeight: "600",
                      borderRadius: "8px",
                      padding: "10px 20px",
                    }}
                  >
                    + ADD BRANCH
                  </Link>
                </div>

                {/* Info Banner */}
                <div
                  style={{
                    backgroundColor: "#f0f7ff",
                    border: "1px solid #d0e3f8",
                    padding: "15px 20px",
                    borderRadius: "8px",
                    display: "flex",
                    gap: "15px",
                    marginBottom: "30px",
                    color: "#3a6d99",
                  }}
                >
                  <i
                    className="fa fa-code-branch"
                    style={{ fontSize: "20px", marginTop: "2px" }}
                  ></i>
                  <p
                    style={{ margin: "0", fontSize: "14px", lineHeight: "1.5" }}
                  >
                    Branches share your menu automatically. Switch into a branch
                    from the location menu in the header to view its details, or
                    send a manager a login so they can manage stock themselves.
                  </p>
                </div>

                {/* Branch Cards */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(400px, 1fr))",
                    gap: "20px",
                  }}
                >
                  {branches.map((branch) => (
                    <div
                      key={branch._id}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #eee",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      {/* Top Section */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <div
                            style={{
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#f0f4f8",
                              borderRadius: "10px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#003a6b",
                              fontWeight: "700",
                              fontSize: "18px",
                              overflow: "hidden",
                            }}
                          >
                            {branch?.logo || storeData?.data?.logo ? (
                              <img
                                src={branch?.logo || storeData?.data?.logo}
                                alt={branch.storeName}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : branch.storeName ? (
                              branch.storeName.substring(0, 2).toUpperCase()
                            ) : (
                              "BR"
                            )}
                          </div>
                          <div>
                            <h3
                              style={{
                                margin: "0",
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "#333",
                              }}
                            >
                              {branch.storeName}
                            </h3>
                            <p
                              style={{
                                margin: "5px 0 0 0",
                                fontSize: "12px",
                                color: "#888",
                              }}
                            >
                              {branch.storeNumber || "B-001"} ·{" "}
                              {branch.address
                                ? branch.address.split(",")[1] || "Location"
                                : "Location"}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <span
                            style={{
                              backgroundColor: "#e6f4ea",
                              color: "#1e8e3e",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Branch
                          </span>
                          {branch.adminVerificationStatus === "Pending" && (
                            <span
                              style={{
                                backgroundColor: "#fef3c7",
                                color: "#92400e",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              Awaiting approval
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Details Section */}
                      <div style={{ marginBottom: "25px" }}>
                        <p
                          style={{
                            margin: "0 0 10px 0",
                            fontSize: "13px",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <i
                            className="fa fa-map-marker"
                            style={{ width: "15px", textAlign: "center" }}
                          ></i>{" "}
                          {branch.address || "Address not provided"}
                        </p>
                        <p
                          style={{
                            margin: "0 0 10px 0",
                            fontSize: "13px",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <i
                            className="fa fa-user"
                            style={{ width: "15px", textAlign: "center" }}
                          ></i>{" "}
                          {branch.managerName || "Manager not specified"}
                        </p>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "13px",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <i
                            className="fa fa-envelope"
                            style={{ width: "15px", textAlign: "center" }}
                          ></i>{" "}
                          {branch.email || "No manager email"}
                        </p>
                      </div>

                      {branch.adminVerificationStatus === "Pending" && (
                        <div
                          style={{
                            backgroundColor: "#fffbeb",
                            border: "1px solid #fde68a",
                            borderRadius: "8px",
                            padding: "15px",
                            display: "flex",
                            gap: "12px",
                            alignItems: "flex-start",
                            marginBottom: "25px",
                            color: "#92400e",
                            fontSize: "13px",
                          }}
                        >
                          <i
                            className="fa fa-lock"
                            style={{ fontSize: "16px", marginTop: "2px" }}
                          ></i>
                          <span style={{ lineHeight: "1.4" }}>
                            Submitted to admin — hidden from customers until
                            approved.
                          </span>
                        </div>
                      )}

                      {/* Bottom Section */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          borderTop: "1px solid #f0f0f0",
                          paddingTop: "15px",
                        }}
                      >
                        <span
                          style={{
                            color:
                              branch.adminVerificationStatus === "Pending"
                                ? "#b47a16"
                                : branch.status === "Active"
                                  ? "#1e8e3e"
                                  : "#d93025",
                            fontWeight: "700",
                            fontSize: "14px",
                          }}
                        >
                          {branch.adminVerificationStatus === "Pending"
                            ? "Pending approval"
                            : branch.status || "Active"}
                        </span>
                        <div style={{ display: "flex", gap: "10px" }}>
                          {branch.adminVerificationStatus !== "Pending" && (
                            <>
                              <button
                                onClick={() => handleOpenAddModal(branch)}
                                className="btn"
                                style={{
                                  border: "1px solid #003a6b",
                                  color: "#003a6b",
                                  backgroundColor: "#fff",
                                  padding: "6px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-plus"></i> ADD ITEM
                              </button>
                              <Link
                                to={`/branch-details/${branch._id}`}
                                className="btn"
                                style={{
                                  border: "1px solid #28a745",
                                  color: "#28a745",
                                  padding: "6px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  backgroundColor: "#fff",
                                }}
                              >
                                <i className="fa fa-eye"></i> VIEW
                              </Link>
                            </>
                          )}
                          <Link
                            to={`/branch-edit/${branch._id}`}
                            className="btn"
                            style={{
                              border: "1px solid #003a6b",
                              color: "#003a6b",
                              padding: "6px 20px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: "600",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <i className="fa fa-pencil"></i> EDIT
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedBranchForAdd && (
        <AddBranchItemModal
          show={showAddModal}
          handleClose={handleCloseAddModal}
          branchName={selectedBranchForAdd.storeName}
          branchId={selectedBranchForAdd._id}
          storeId={storeData?.data?._id}
          storeCategoryId={selectedBranchForAdd.storeCategory?._id}
        />
      )}
    </>
  );
};

export default BranchManagement;
